import webBiLogger from '@wix/web-bi-logger';
import {
  getAppUrl,
  getAppVersion,
  BI_ARENA_ENDPOINT,
  BI_SOURCE,
  loggerFactory,
} from '@wix/experts-common';

export default () => {
  const factory = webBiLogger
    .factory({ endpoint: BI_ARENA_ENDPOINT })
    .updateDefaults({
      src: BI_SOURCE,
      appVersion: getAppVersion(getAppUrl('experts-arena')),
    });

  return loggerFactory(factory);
};
